module.exports = __webpack_public_path__ + "img/future.87cc60b6.jpg";